<app-base-modal [isOpen]="isOpen" (close)="close.emit()">
  <h1 header>Fax Info</h1>

  <div class="fax-info-modal">
    <span class="fax-info-modal__label">Message:</span>
    <span class="fax-info-modal__value">{{ fax?.id }}</span>

    <span class="fax-info-modal__label">Connection:</span>
    <span class="fax-info-modal__value">{{ fax?.connectionId }}</span>

    <span class="fax-info-modal__label">From:</span>
    <span class="fax-info-modal__value">{{ fax?.fromNumber }}</span>

    <span class="fax-info-modal__label">Total Pages:</span>
    <span class="fax-info-modal__value">{{ fax?.pages }}</span>

    <span class="fax-info-modal__label">To:</span>
    <span class="fax-info-modal__value">{{ fax?.toNumber }}</span>

    <span class="fax-info-modal__label">Created At:</span>
    <span class="fax-info-modal__value">{{ formatDate(fax?.createdAt) }}</span>

    <span class="fax-info-modal__label">Status:</span>
    <span class="fax-info-modal__value">{{ fax?.status }}</span>

    <span class="fax-info-modal__label">Updated At:</span>
    <span class="fax-info-modal__value">{{ formatDate(fax?.updatedAt) }}</span>

    <span class="fax-info-modal__label">Direction:</span>
    <span class="fax-info-modal__value">{{ fax?.direction }}</span>

    <span class="fax-info-modal__label">Delivery ID:</span>
    <span class="fax-info-modal__value">{{ fax?.externalId }}</span>
  </div>
</app-base-modal>
